"use client";

import Link from "next/link";

export default function JobError({ reset }: { reset: () => void }) {
  return <main className="min-h-screen bg-[#0b1628] px-5 py-16 text-[#e2eaf5]">
    <div className="mx-auto max-w-3xl"><h1 className="text-3xl font-bold">Job temporarily unavailable</h1>
      <p className="mt-4 text-slate-300">Please try again shortly.</p>
      <button onClick={reset} className="mt-6 rounded-lg bg-amber-400 px-5 py-3 font-semibold text-slate-950">Try again</button>
      <Link href="/public/jobs" className="ml-5 text-cyan-300">Browse open jobs</Link>
    </div>
  </main>;
}
